module.exports = __webpack_public_path__ + "static/media/logo_kx.c56125c5.png";